
    <input *ngIf="!isShowText" type="text" twoDigitDecimaNumber appBlockCopyPaste [maxlength]="maxLength" 
    class="date-right-panel border text-right  bg-white rounded padding-left-5 padding-bottom-10 text-renderer padding-right5 w-100pc"
    [(ngModel)]="value" (input)="onInput($event)" (keydown)="onKeyDown($event)" [placeholder]="placeHolder" 
    [ngClass]="{'border-danger': isRequired && showValidator,'border-secondary': !(isRequired && showValidator),
     'disabled bg-light-grey': this.disabled }" tabindex="0">
 
  <span *ngIf="isShowText"> {{ value }}</span>